import { createRoot } from "react-dom/client";
import { Modal } from "bootstrap";

export default function Confirm(cb) {

    let shown = true;

    const cancelled = () => {
        container.off('hide.bs.modal');
        container.remove();
    }

    const confirmed = () => {
        shown = false;
        modal.hide();
        cb();
    }

    const container = $('<div class="modal fade" tabindex="-1"><div class="modal-dialog modal-dialog-centered"><div class="modal-content"></div></div></div>');
    $('body').append(container);
    const modalContent = $('.modal-content', container)[0];
    const modal = new Modal(container);
    container.on('hide.bs.modal', cancelled);
    createRoot(modalContent).render(
        <div className="modal-body text-center">
            <h1 className="mb-4">{t.commonConfirm}</h1>
            <button type="button" className="btn btn-lg btn-secondary me-3" data-bs-dismiss="modal">{t.commonNo}</button>
            <button onClick={confirmed} type="button" className="btn btn-lg btn-primary">{t.commonYes}</button>
        </div>);

    modal.show();
}